export const funCfg = {}
export const textCfg = {}
funCfg.h5Type = 2 // 1=琴房 2=教室 3=办公室
if (funCfg.h5Type === 1) {
  textCfg.title = '掌上琴房'
  textCfg.roomName = '琴房'
  textCfg.idNum = '学工号'
  textCfg.fromType = '专业'
  textCfg.signInText = '签到成功！可以开始练琴了！'
  textCfg.loginTit = '校园'
} else if (funCfg.h5Type === 2) {
  textCfg.title = '微格教室'
  textCfg.roomName = '教室'
  textCfg.idNum = '学工号'
  textCfg.fromType = '专业'
  textCfg.signInText = '签到成功！可以开始使用了！'
  textCfg.loginTit = '校园'
} else if (funCfg.h5Type === 3) {
  textCfg.title = '掌上办公室'
  textCfg.roomName = '办公室'
  textCfg.idNum = '工号'
  textCfg.fromType = '部门'
  textCfg.signInText = '签到成功！可以开始使用了！'
  textCfg.loginTit = '统一'
}

funCfg.openFace = false // 是否开放人脸
funCfg.openMyCourse = false // 是否在我的里面打开课程
funCfg.openContinueBook = false // 是否支持续约
funCfg.openScanCode = true // 是否扫码
funCfg.showRoomListDetail = false // 是否房间列表显示详情
funCfg.showRoomListManyName = false // 是否房间列表显示尽量多的名称
funCfg.openRoomTimeRule = false // 是否支持房间自定义时间段
funCfg.oauthLoginChannel = '' // 如果开放 oauth 登录, 使用的渠道
funCfg.openBackSignIn = true // 是否开放返回签入
// 开门方式
funCfg.openQrCodeOpenDoor = true // 是否支持二维码开门
funCfg.openPasswordOpenDoor = false // 是否支持密码开门
funCfg.openStudentIdOpenDoor = false // 是否支持学号开门
funCfg.showH5Capacity = false // 是否启用预约填写人数
funCfg.showSVGCode = false // 是否随机图片登录
funCfg.hideWhiteList = true // 是否隐藏白名单
funCfg.h5LoginDuration = 7 * 24 * 3600 // 登录时长
funCfg.buildNoUnit = ''
funCfg.floorNoUnit = ''
